<template>
<div>
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>「デザイン地図AI」利用規約</title>
  </head>
  <body>
    <div class="terms-container">
      <div class="terms-content">
        <h1 class="terms-title">「デザイン地図AI」利用規約</h1>

        <div class="terms-introduction">
          <p>
            株式会社ゼンリンデータコム（以下「当社」）が提供する「デザイン地図AI」（以下「本サービス」）は、この利用規約（以下「本規約」）に従って提供されます。本サービスを利用する方（以下「利用者」）は、本規約に同意されない場合、本サービスを利用することはできません。なお、当社が本規約以外に本サービス上に掲載するヘルプ、注意事項等も、本規約の一部を実質的に構成するものとします。
          </p>
        </div>

        <div class="terms-section">
          <h2>第１条 利用許諾等</h2>
          <ol>
            <li>
              利用者は、本サービスにおいて、地図データ、施設データ、その他情報データ（以下総称して「地図データ等」）、及びその他当社が定めるサービスを次項の定めに従って利用することができます。
            </li>
            <li>
              当社は、本サービス上又は当社のWebサイトに定める方法に従い、利用者が管理又は保有する端末において、本サービスを個人的かつ非商用目的に限り利用する、非独占的な権利を、利用者に対し許諾します。
            </li>
          </ol>
        </div>

        <div class="terms-section">
          <h2>第２条 本規約の改訂</h2>
          <ol>
            <li>
              当社は、当社の判断により、本規約をいつでも任意の理由で変更することができるものとします。
            </li>
            <li>
              変更後の利用規約は、当社が別途定める場合を除いて、本サービス上に表示した時点より効力が生じるものとします。
            </li>
            <li>
              利用者が、本規約の効力が生じた後に本サービスを利用した場合は、変更後の利用規約に同意したものとみなされます。
            </li>
          </ol>
        </div>

        <div class="terms-section">
          <h2>第３条 知的財産権</h2>
          <p>
            本サービス及び地図データ等（利用者により作成された地図データを含む）に関する著作権、商標権、特許権等の知的財産権、その他一切の権利は、当社又は当社に権利を許諾した第三者に帰属するものとします。
          </p>
        </div>

        <div class="terms-section">
          <h2>第４条 利用者の責任</h2>
          <ol>
            <li>
              利用者は、本規約、本サービス上又は当社が別途定める操作方法、操作上の注意事項等に従って本サービスを利用してください。
            </li>
            <li>利用者は、利用者自身の責任において本サービスを利用するものとします。</li>
            <li>
              利用者は、本サービスとリンクするSNS（Social Network Service）等の他社が提供するサービスを利用する場合、自己の責任において当該サービスを利用するものとし、これにより生じた損害について、当社は一切の責任をおいません。
            </li>
            <li>
              利用者は、本規約に違反した行為又は違法行為によって当社に損害を与えた場合、当社が被った全ての損害（弁護士費用等を含む）を賠償する責任を負うものとします。
            </li>
          </ol>
        </div>

        <div class="terms-section">
          <h2>第５条 禁止事項</h2>
          <p>
            当社が別途明示的に許諾する場合を除き、利用者は、本サービスの利用にあたり次の各号に定める事項を行ってはなりません。
          </p>
          <ol>
            <li>
              リバースエンジニアリング、逆コンパイル、逆アセンブルその他これらに準じる行為をすること。
            </li>
            <li>
              複製、転記、抽出、加工、改変、翻訳、翻案、頒布、公衆送信、二次的著作物の作成その他の利用をすること。
            </li>
            <li>
              第三者の知的財産権、肖像権、パブリシティ権、プライバシー権、信用、人格権など他人の権利を侵害し、またこれらの権利侵害を助長する行為をすること。
            </li>
            <li>営利目的又は商業目的に利用すること。</li>
            <li>
              本サービス及び本サービスに含まれるデータを、本サービスを利用する目的以外に使用すること。
            </li>
            <li>
              法令に違反する行為の実行を誘引する行為又は違法行為の捜査を妨げる行為をすること。
            </li>
            <li>
              本サービスの機能性を妨害、破壊、制限するコンピューターウイルス、コンピューターコード、ファイル又はプログラムを送信すること。
            </li>
            <li>公序良俗に反する行為をすること。</li>
            <li>
              その他、本サービスの管理及び運営のために、当社が不適当であると合理的に判断する行為をすること。
            </li>
          </ol>
        </div>

        <div class="terms-section">
          <h2>第６条 免責事項</h2>
          <ol>
            <li>
              当社は、本規約に明示的に記載される場合又は法令により別段の定めがある場合を除き、本サービスを利用したこと又は利用できなかったことから生じる損害・損失に関して、いかなる責任も負いません。
            </li>
            <li>
              当社は、本サービスにおいて利用者に提供される全ての情報の正確性・完全性・特定の目的に対する適合性、端末上での正常な動作や機能性、また本サービスに瑕疵がなく、知的財産権の侵害がないこと、その他明示又は黙示を問わず、本サービスに関連する一切の保証をしないものとします。
            </li>
            <li>前各項の規定は、当社に故意又は重過失がある場合はこの限りではありません。</li>
          </ol>
        </div>

        <div class="terms-section">
          <h2>第７条 利用者の情報の取り扱い</h2>
          <p>
            当社は、利用者による本サービスの利用目的を分析するため、又は個々の利用者に対してより良いサービスを提供する等の目的のために、利用者のクッキー（Cookie）及び類似の技術で取得した情報を、「外部送信ポリシー（<a
              :href="`https://${hostname}/design_map_ai/externalTransmissionPolicy`"
              target="_blank"
              >https://{{ hostname }}/design_map_ai/externalTransmissionPolicy</a
            >）」に従って収集し、「外部送信ポリシー」において定める目的でのみ利用するものとします。
          </p>
        </div>

        <div class="terms-section">
          <h2>第８条 AI技術の利用</h2>
          <ol>
            <li>
              本サービスでは、一部の機能にAI（人工知能であり、Artificial Intelligenceの略称をいう。以下「AI」）技術を利用しています。AI技術は、地図編集機能を提供するためにのみ利用されることから、当社がAI技術を用いて利用者の個人情報を取り扱うことはありません。
            </li>
            <li>
              当社は、利用者が前項の機能を利用し入力した情報をログとして保管します。
            </li>
            <li>
              利用者は、第１項の機能を、地図編集の目的のためにのみ使用することができるものとし、これ以外の目的に利用してはならないものとします。
            </li>
          </ol>
        </div>

        <div class="terms-section">
          <h2>第９条 本サービスの提供中止</h2>
          <p>
            当社は、利用者へ事前に通知することなく、当社の裁量によって、本サービスの一部若しくは全部の提供を中断、終了又は機能の変更をする場合があります。
          </p>
        </div>

        <div class="terms-section">
          <h2>第１０条 一般条項</h2>
          <ol>
            <li>
              本規約のいずれかの条項又はその一部が法令等により無効又は執行不能と判断された場合であっても、当該条項又は当該一部以外の本規約の条項の効力には何ら影響を与えないものとします。
            </li>
            <li>
              利用者と当社間に本規約の解釈その他につき疑義又は紛争が生じた場合には、両者は誠意をもって協議し解決に努めるものとします。
            </li>
            <li>本規約に記載のない事項については、当社の判断によるものとします。</li>
            <li>本規約の準拠法は、日本法とします。</li>
            <li>
              本サービスに関連して、訴訟の必要が生じた場合は、日本国の東京地方裁判所を第一審の専属的合意管轄裁判所とします｡
            </li>
          </ol>
        </div>

        <div class="terms-footer">
          <p>制定日：2025年3月25日</p>
          <!-- <p class="terms-note">
            ※本サービスのうち、道の駅データについては、「道の駅」一覧（国土交通省）（<a
              href="https://www.mlit.go.jp/road/Michi-no-Eki/list.html"
              target="_blank"
              >https://www.mlit.go.jp/road/Michi-no-Eki/list.html</a
            >）を加工して作成しています。
          </p> -->
        </div>
      </div>
    </div>
  </body>
</div>
</template>

<script>
export default {
  name: 'TermsOfUse',
  data () {
    return {
      hostname: window.location.hostname
    }
  }
}
</script>

<!-- <script setup>
  const hostname = window.location.hostname
</script> -->

<style scoped>
  .terms-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    background-color: #ffffff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }

  .terms-content {
    padding: 20px;
    line-height: 1.8;
    color: #333333;
  }

  .terms-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 30px;
    text-align: center;
    color: #1a1a1a;
  }

  .terms-introduction {
    margin-bottom: 30px;
  }

  .terms-section {
    margin-bottom: 30px;
  }

  .terms-section h2 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #1a1a1a;
  }

  .terms-section ol {
    padding-left: 20px;
    margin-bottom: 15px;
  }

  .terms-section ol li {
    margin-bottom: 10px;
  }

  .terms-section ol ol {
    list-style-type: lower-roman;
    padding-left: 25px;
    margin-top: 10px;
  }

  .terms-footer {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #eee;
    font-size: 14px;
    color: #666;
  }

  .terms-note {
    margin-top: 15px;
    font-size: 12px;
    color: #777;
  }

  a {
    color: #007bff;
    text-decoration: none;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  a:hover {
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    .terms-container {
      padding: 10px;
      margin: 10px;
    }

    .terms-content {
      padding: 15px;
    }

    .terms-title {
      font-size: 20px;
    }

    .terms-section h2 {
      font-size: 16px;
    }
  }
</style>
